import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <ol>
                <li>
                  Ahmad, A., W. Hassan, S., &amp; Banat, F. (2022). An overview
                  of microalgae biomass as a sustainable aquaculture feed
                  ingredient: Food security and circular economy.{" "}
                  <em>Bioengineered</em>, <em>13</em>(4),9521-9547.
                </li>
                <li>
                  Ammar, E. E., Aioub, A. A., Elesawy, A. E., Karkour, A. M.,
                  Mouhamed, M. S., Amer, A. A., &amp; El-Shershaby, N. A.
                  (2022). Algae as Bio-fertilizers: Between current situation
                  and future prospective.{" "}
                  <em>Saudi Journal of Biological Sciences</em>,<em>29</em>
                  (5),3083-3096.
                </li>
                <li>
                  Amos, W. A. (2004). Updated cost analysis of photobiological
                  hydrogen production from Chlamydomonas reinhardtii green
                  algae: milestone completion report (No. NREL/MP-560-35593).
                  National Renewable Energy Lab., Golden, CO.(US).
                </li>
                <li>
                  APHA (2012). Standard Methods (20 Ed.) for the examination of
                  water and wastewater, APHA, AWWA, WPCE, Washington DC.
                </li>
                <li>
                  Arrigo, K. R., Mills, M. M., Kropuenske, L. R., van Dijken, G.
                  L., Alderkamp, A. C., &amp; Robinson, D. H. (2010).
                  Photophysiology in Two Major Southern Ocean Phytoplankton
                  Taxa: Photosynthesis and Growth of Phaeocystis antarctica and
                  Fragilariopsis cylindrus under Different Irradiance Levels.{" "}
                  <em>Integrative and Comparative Biology</em>,<em>50</em>
                  (6),950&ndash;966.
                </li>
                <li>
                  Asulabha, K.S., Jaishanker, R., Sincy, V., &amp; Ramachandra,
                  T.V. (2022). Diversity of phytoplankton in lakes of Bangalore,
                  Karnataka, India. 10th Chapter, In: Shashikanth Majige (eds),
                  Biodiversity Challenges: A way forward, Daya Publishing House,
                  New Delhi, 147-178.
                </li>
                <li>
                  Camargo, J. A., &amp; Alonso, &Aacute;. (2006). Ecological and
                  toxicological effects of inorganic nitrogen pollution in
                  aquatic ecosystems: a global assessment.{" "}
                  <em>Environment International</em>, <em>32</em>(6),831-849.
                </li>
                <li>
                  Condor, B.E., de Luna, M.D.G., Chang, Y.H., Chen, J.H., Leong,
                  Y.K., Chen, P.T., Chen, C.Y., Lee, D.J., &amp; Chang, J.S.
                  (2022). Bioethanol production from microalgae biomass at
                  high-solids loadings. <em>Bioresource Technology</em>,
                  <em>363</em>,128002.
                </li>
                <li>
                  Crossetti, L. O., &amp; Bicudo, C. E. D. M. (2005). Structural
                  and functional phytoplankton responses to nutrient
                  impoverishment in mesocosms placed in a shallow eutrophic
                  reservoir (Gar&ccedil;as Pond), S&atilde;o Paulo, Brazil.{" "}
                  <em>Hydrobiologia</em>,<em>541</em>,71-85.
                </li>
                <li>
                  Desikachary, T.V. (1959). Cyanophyta. Indian Council for
                  Agricultural Research, New Delhi.
                </li>
                <li>
                  Garc&iacute;a, J. L., De Vicente, M., &amp; Gal&aacute;n, B.
                  (2017). Microalgae, old sustainable food and fashion
                  nutraceuticals. <em>Microbial biotechnology</em>,<em>10</em>
                  (5),1017.
                </li>
                <li>
                  Guiry, M.D. &amp; Guiry, G.M. 2023. AlgaeBase. World-wide
                  electronic publication, National University of Ireland,
                  Galway. https://www.algaebase.org
                </li>
                <li>
                  Han, P., Lu, Q., Fan, L., &amp; Zhou, W. (2019). A review on
                  the use of microalgae for sustainable aquaculture.{" "}
                  <em>Applied Sciences</em>,<em>9</em>(11),2377.
                </li>
                <li>
                  Harun, R., Danquah, M. K., &amp; Forde, G. M. (2010).
                  Microalgal biomass as a fermentation feedstock for bioethanol
                  production.{" "}
                  <em>Journal of Chemical Technology &amp; Biotechnology</em>,{" "}
                  <em>85</em>(2),199-203.
                </li>
                <li>
                  Johnstone, C., Day, J. G., Staines, H., &amp; Benson, E. E.
                  (2006). The development of a 2,
                  2&prime;-azinobis-(3-ethyl-benzothiazoline-6-sulfonic acid)
                  radical cation decolourisation assay for evaluating total
                  antioxidant status in an alga used to monitor environmental
                  impacts in urban aquatic habitats.{" "}
                  <em>Ecological Indicators</em>,<em>6</em>(2),280-289.
                </li>
                <li>
                  Khalil, S., Mahnashi, M. H., Hussain, M., Zafar, N., Khan, F.
                  S., Afzal, U., Shah, G. M., Niazi, U. M., Awais, M. &amp;
                  Irfan, M. (2021). Exploration and determination of algal role
                  as Bioindicator to evaluate water quality&ndash;Probing fresh
                  water algae. <em>Saudi Journal of Biological Sciences</em>,
                  <em>28</em>(10),5728-5737.
                </li>
                <li>
                  Khan, M., Hussain, F., &amp; Musharaf, S. (2011). A fraction
                  of fresh water algae of Kalpani stream and adjoining area of
                  district Mardan, Pakistan.{" "}
                  <em>International Journal of Biosciences</em>, <em>1</em>
                  (3),45-50.
                </li>
                <li>
                  Khan, S., Das, P., Abdul Quadir, M., Thaher, M. I., Mahata,
                  C., Sayadi, S., &amp; Al-Jabri, H. (2023). Microalgal
                  feedstock for biofuel production: recent advances, challenges,
                  and future perspective. <em>Fermentation</em>,<em>9</em>
                  (3),281.
                </li>
                <li>
                  Kim, M. S., Ahn, S. H., Jeong, I. J., &amp; Lee, T. K. (2021).
                  Water quality drives the regional patterns of an algal
                  metacommunity in interconnected lakes.{" "}
                  <em>Scientific Reports</em>,<em>11</em>(1).
                </li>
                <li>
                  Kiran, B. R., &amp; Venkata Mohan, S. (2021). Microalgal cell
                  biofactory&mdash;therapeutic, nutraceutical and functional
                  food applications. <em>Plants</em>,<em>10</em>(5),836.
                </li>
                <li>
                  Kumar, S., Sindhu, S. S., &amp; Kumar, R. (2022).
                  Biofertilizers: An ecofriendly technology for nutrient
                  recycling and environmental sustainability.{" "}
                  <em>Current Research in Microbial Sciences</em>, <em>3</em>
                  ,100094.
                </li>
                <li>
                  Li, X., Yu, H., Wang, H., &amp; Ma, C. (2019). Phytoplankton
                  community structure in relation to environmental factors and
                  ecological assessment of water quality in the upper reaches of
                  the Genhe River in the Greater Hinggan Mountains.{" "}
                  <em>Environmental Science and Pollution Research,26</em>
                  (17),17512&ndash;17519.
                </li>
                <li>
                  Liu, X., Lu, X., &amp; Chen, Y. (2011). The effects of
                  temperature and nutrient ratios on Microcystis blooms in Lake
                  Taihu, China: An 11-year investigation.{" "}
                  <em>Harmful Algae,10</em>(3), 337&ndash;343.
                </li>
                <li>
                  Mohammed, K. A., &amp; Mahran, B. N. (2022). Environmental
                  studies on phytoplankton diversity in drainage water of main
                  drains in Eastern Delta, case study.{" "}
                  <em>The Egyptian Journal of Aquatic Research</em>,<em>48</em>
                  (3),211-216.
                </li>
                <li>
                  Molino, A., Mehariya, S., Iovine, A., Larocca, V., Di Sanzo,
                  G., Martino, M., Casella, P., Chianese, S., &amp; Musmarra, D.
                  (2018). Extraction of astaxanthin and lutein from microalga
                  Haematococcus pluvialis in the red phase using CO<sub>2</sub>{" "}
                  supercritical fluid extraction technology with ethanol as
                  co-solvent. <em>Marine Drugs</em>,<em>16</em>(11),432.
                </li>
                <li>
                  Moradi, P., &amp; Saidi, M. (2022). Biodiesel production from
                  Chlorella Vulgaris microalgal-derived oil via electrochemical
                  and thermal processes. <em>Fuel Processing Technology</em>,
                  <em>228</em>, 107158.
                </li>
                <li>
                  Nguyen, M. T., Choi, S. P., Lee, J. W., Lee, J. H., &amp; Sim,
                  S. J. (2009). Hydrothermal acid pretreatment of Chlamydomonas
                  reinhardtii biomass for ethanol production.{" "}
                  <em>Journal of Microbiology and Biotechnology</em>,<em>19</em>
                  (2),161-166.
                </li>
                <li>
                  Paerl, H. W., Dyble, J., Moisander, P. H., Noble, R. T.,
                  Piehler, M. F., Pinckney, J. L., Steppe, T. F., Twomey, L.
                  &amp; Valdes, L. M. (2003). Microbial indicators of aquatic
                  ecosystem change: current applications to eutrophication
                  studies. <em>FEMS Microbiology Ecology</em>, <em>46</em>(3),
                  233-246.
                </li>
                <li>
                  Prescott, G.W. (1970). How to Know Freshwater Algae.2nd ed.,
                  W.C. Brown. Dubuque, Iowa.
                </li>
                <li>
                  Pulz, O., &amp; Gross, W. (2004). Valuable products from
                  biotechnology of microalgae.{" "}
                  <em>Applied Microbiology and Biotechnology</em>,<em>65</em>
                  ,635-648.
                </li>
                <li>
                  Rahman, M. A., Aziz, M. A., Al-Khulaidi, R. A., Sakib, N.,
                  &amp; Islam, M. (2017). Biodiesel production from microalgae
                  Spirulina maxima by two step process: Optimization of process
                  variable.{" "}
                  <em>Journal of Radiation Research and Applied Sciences</em>,
                  <em>10</em>(2),140-147.
                </li>
                <li>
                  Ramachandra, T.V., Sincy, V., &amp; Asulabha, K.S. (2020).
                  Efficacy of rejuvenation of lakes in Bengaluru, India.{" "}
                  <em>Green Chemistry &amp; Technology Letters</em>, <em>6</em>
                  (1), 14-26.
                </li>
                <li>
                  Ramachandra, T.V., Sincy, V., &amp; Asulabha, K.S. (2021).
                  Accounting of ecosystem services of wetlands in Karnataka
                  State, India. <em>REaD</em>, <em>18</em>, 1-26.
                </li>
                <li>
                  Rempel, A., de Souza Sossella, F., Margarites, A.C., Astolfi,
                  A.L., Steinmetz, R.L.R., Kunz, A., Treichel, H. and Colla,
                  L.M., 2019. Bioethanol from Spirulina platensis biomass and
                  the use of residuals to produce biomethane: An energy
                  efficient approach. <em>Bioresource Technology</em>,{" "}
                  <em>288</em>,121588.
                </li>
                <li>
                  Rodolfi, L., Zittelli, C. G., Bassi, N., Padovani, G., Biondi,
                  N., Bonini, G., &amp; Tredici, M. R. (2009). Microalgae for
                  oil: Strain selection, induction of lipid synthesis and
                  outdoor mass cultivation in a low‐cost photobioreactor.{" "}
                  <em>Biotechnology and Bioengineering</em>, <em>102</em>(1),
                  100-112.
                </li>
                <li>
                  Sarma, S., Sharma, S., Rudakiya, D., Upadhyay, J., Rathod, V.,
                  Patel, A., &amp; Narra, M. (2021). Valorization of microalgae
                  biomass into bioproducts promoting circular bioeconomy: a
                  holistic approach of bioremediation and biorefinery.{" "}
                  <em>3 Biotech</em>,<em>11</em>,1-29.
                </li>
                <li>
                  Sharma, P., Gujjala, L. K. S., Varjani, S., &amp; Kumar, S.
                  (2022). Emerging microalgae-based technologies in biorefinery
                  and risk assessment issues: Bioeconomy for sustainable
                  development. <em>Science of The Total Environment</em>,{" "}
                  <em>813</em>, 152417.
                </li>
                <li>
                  Sivaramakrishnan, R., Suresh, S., Kanwal, S., Ramadoss, G.,
                  Ramprakash, B., &amp; Incharoensakdi, A. (2022). Microalgal
                  biorefinery concepts&rsquo; developments for biofuel and
                  bioproducts: Current perspective and bottlenecks.{" "}
                  <em>International Journal of Molecular Sciences</em>,
                  <em>23</em>(5),2623.
                </li>
                <li>
                  Spolaore, P., Joannis-Cassan, C., Duran, E., &amp; Isambert,
                  A. (2006). Commercial applications of microalgae.{" "}
                  <em>Journal of Bioscience and Bioengineering</em>,<em>101</em>
                  (2),87-96.
                </li>
                <li>
                  Subhadra, B. G., &amp; Edwards, M. (2011). Coproduct market
                  analysis and water footprint of simulated commercial algal
                  biorefineries. <em>Applied Energy</em>,<em>88</em>
                  (10),3515-3523.
                </li>
                <li>
                  Torri, C., Samor&igrave;, C., Adamiano, A., Fabbri, D.,
                  Faraloni, C., &amp; Torzillo, G. (2011). Preliminary
                  investigation on the production of fuels and bio-char from
                  Chlamydomonas reinhardtii biomass residue after bio-hydrogen
                  production. <em>Bioresource Technology</em>, <em>102</em>
                  (18),8707-8713.
                </li>
                <li>
                  Udayan, A., Pandey, A.K., Sirohi, R., Sreekumar, N., Sang,
                  B.I., Sim, S.J., Kim, S.H. and Pandey, A., 2023. Production of
                  microalgae with high lipid content and their potential as
                  sources of nutraceuticals. <em>Phytochemistry Reviews</em>,
                  <em>22</em>(4),833-860.
                </li>
                <li>
                  Verma, N. M., Mehrotra, S., Shukla, A., &amp; Mishra, B. N.
                  (2010). Prospective of biodiesel production utilizing
                  microalgae as the cell factories: A comprehensive discussion.{" "}
                  <em>African Journal of Biotechnology</em>,<em>9</em>
                  (10),1402-1411.
                </li>
                <li>
                  Wehr, J. D., Sheath, R. G., &amp; Kociolek, J. P. (Eds.).
                  (2015). Freshwater algae of North America: ecology and
                  classification. Elsevier.
                </li>
                <li>
                  Yuan, T., Tahmasebi, A., &amp; Yu, J. (2015). Comparative
                  study on pyrolysis of lignocellulosic and algal biomass using
                  a thermogravimetric and a fixed-bed reactor.{" "}
                  <em>Bioresource Technology</em>,<em>175</em>,333-341.
                </li>
                <li>
                  Zewdie, D. T., &amp; Ali, A. Y. (2022). Techno-economic
                  analysis of microalgal biofuel production coupled with
                  sugarcane processing factories.{" "}
                  <em>South African Journal of Chemical Engineering</em>,
                  <em>40</em>(1),70-79.
                </li>
                <li>
                  Zhan, J., Rong, J., &amp; Wang, Q. (2017). Mixotrophic
                  cultivation, a preferable microalgae cultivation mode for
                  biomass/bioenergy production, and bioremediation, advances and
                  prospect. <em>International Journal of Hydrogen Energy</em>,
                  <em>42</em>(12),8505-8517.
                </li>
                <li>
                  Zhang, Y., Gao, W., Li, Y., Jiang, Y., Chen, X., Yao, Y.,
                  Messyasz, B., Yin, K., He, W. &amp; Chen, Y. (2021).
                  Characteristics of the Phytoplankton community structure and
                  water quality evaluation in autumn in the Huaihe River
                  (China).{" "}
                  <em>
                    International Journal of Environmental Research and Public
                    Health
                  </em>
                  ,<em>18</em>(22),12092.
                </li>
              </ol>
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
